import { render, staticRenderFns } from "./PossibleFinancialChangePlugin.vue?vue&type=template&id=642dc7c3&scoped=true&"
import script from "./PossibleFinancialChangePlugin.vue?vue&type=script&lang=ts&"
export * from "./PossibleFinancialChangePlugin.vue?vue&type=script&lang=ts&"
import style0 from "./PossibleFinancialChangePlugin.vue?vue&type=style&index=0&id=642dc7c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642dc7c3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VDivider,VIcon,VSpacer})
